module.exports = __webpack_public_path__ + "img/cpxq3.2fea410c.png";